// Versão atual do Sisareweb.
// Altere este valor a cada nova publicação/release.
export const APP_VERSION = "1.0.0.0";
